export const AAE_DEV_ONLY = 'aae_dev_only';
export const ACTION_SEGMENT_FILTERS = 'action_segment_filters';
export const BCC = 'brand_control_center';
export const BCCFAI = 'brand_control_center_file_ai_generated';
export const BILLING_SEGMENT_COUNTRY_COUNT = 'billing_segment_country_count';
export const BRAND_CENTER_OFFERS_PAGE = 'brand_center_offers_page';
export const BRAND_CENTER_OFFERS_SETTINGS_TAB =
  'brand_center_offers_settings_tab';
export const BULK_UPLOAD_SOURCE_DOCUMENTS = 'bulk_upload_source_documents';
export const CARRIER_SEGMENTS_ENABLED = 'carrier_segments';
export const COMPLIANCE_BUSINESS_LINKS = 'compliance_business_links';
export const COMPLIANCE_BUSINESS_LINKS_OPT_OUT =
  'compliance_business_links_opt_out';
export const CONVERT = 'convert';
export const CONVERSATION_VIEW_ENABLED = 'conversation_view_enabled';
export const CORDIAL_INTEGRATION = 'cordial_integration';
export const COUPON_PREFIXES = 'coupon_prefixes';
export const DARK_MODE = 'dark_mode';
export const DATA_LABS = 'data_labs';
export const DELIVERABILITY_STATS = 'deliverability_stats';
export const DYNAMIC_TERMS = 'dynamic_terms';
export const ENTITLEMENTS_BRAND_CENTER = 'entitlements_brand_center';
export const ENTITLEMENTS_DATA_INSIGHTS = 'entitlements_data_insights';
export const ENTITLEMENTS_INTEGRATIONS = 'entitlements_integrations';
export const EXEMPT_FROM_SHOP_TOS_GATE =
  'exempt_shop_from_terms_of_service_gate';
export const FLOW_BUILDER_TRANSACTIONAL_AUTOMATIONS =
  'flow_builder_transactional_automations';
export const FB_ASYNC_CAMPAIGN_SUBSCRIBER_COUNT =
  'fb_async_campaign_subscriber_count';
export const FB_BASIC_CAMPAIGNS = 'fb_basic_campaigns';
export const FB_DATE_TRIGGERED_AUTOMATIONS = 'fb_date_triggered_automations';
export const FB_ENHANCED_LINK_TRACKING = 'fb_enhanced_link_tracking';
export const FB_FLOW_TEMPLATES = 'fb_flow_templates';
export const FB_HIDE_SEGMENT_COUNT_IN_CAMPAIGN_PROPS =
  'fb_hide_segment_count_in_campaign_props';
export const FB_FILE_UPLOAD_OPTIMIZATION = 'fb_file_upload_optimization';
export const FB_LOW_INVENTORY_AUTOMATIONS = 'fb_low_inventory';
export const FB_MULTI_SEGMENT_CAMPAIGNS = 'fb_multi_segment_campaigns';
export const FB_OPTIMIZED_AB_SPLIT_ACTION = 'fb_optimized_ab_split_action';
export const FB_CONSENT_VERIFICATION = 'fb_consent_verification';
export const FB_PREVENT_INITIAL_WAIT_ACTION = 'fb_prevent_initial_wait_action';
export const FB_PRICE_DROP_AUTOMATIONS = 'fb_price_drop_automations';
export const FB_RANDOM_WAIT_ACTION_CATEGORY = 'fb_random_wait_action_category';
export const FB_RECOMMENDED_SEND_TIME = 'fb_recommended_send_time';
export const FB_SCHEDULE_AUTOMATION_DEACTIVATION =
  'fb_schedule_automation_deactivation';
export const FB_SUBSCRIBER_RETENTION = 'fb_subscriber_retention';
export const FB_WAIT_SUBSCRIBER_TZ = 'fb_wait_subscriber_tz';
export const FB_WAIT_SUBSCRIBER_TZ_NEXT = 'fb_wait_subscriber_tz_next'; // Merge with above flag when ready
export const GORGIAS_V2 = 'gorgias_v2';
export const ITERABLE_INTEGRATION = 'iterable_integration';
export const KLAVIYO_OAUTH = 'klaviyo_oauth';
export const LANDING_PAGES_USE_DEFAULT_TEMPLATE =
  'landing_pages_use_default_template';
export const LISTRAK_INTEGRATION = 'listrak_integration';
export const MAILCHIMP_INTEGRATION = 'mailchimp_integration';
export const MANUAL_ROUTE_TO_EMAIL = 'manual_route_to_email';
export const OMNISEND_INTEGRATION = 'omnisend_integration';
export const OMNI_SANDBOX = 'omni_sandbox';
export const OMNI_TRENDS = 'omni_trends';
export const POPUP_AI_RETRIGGERING = 'popup_ai_retriggering';
export const POPUP_AI_VARIANT_GENERATION = 'popup_ai_variant_generation';
export const POPUP_BLOCK_SMS_COMPLIANCE_LANGUAGE_LAYOUT =
  'popup_block_sms_compliance_language_layout';
export const POPUP_BUTTON_GROUP = 'popup_button_group';
export const POPUP_CLONE_POPUP_ACROSS_SHOPS = 'popup_clone_popup_across_shops';
export const POPUP_DOUBLE_OPT_IN_OPTION = 'popup_double_opt_in_option';
export const POPUP_EMAIL_VALIDATION = 'popup_email_validation';
export const POPUP_EXIT_INTENT = 'popup_exit_intent';
export const POPUP_FOCUS_STYLING = 'popup_focus_styling';
export const POPUP_HOVER_STYLING = 'popup_hover_styling';
export const POPUP_INCREASE_AB_TEST_LIMIT = 'popup_increase_ab_test_limit';
export const POPUP_LETTER_AND_LINE_SPACING =
  'popup_block_letter_and_line_spacing';
export const POPUP_MIGRATION_LEGACY_TO_BLOCK =
  'popup_migration_legacy_to_block';
export const POPUP_LINK_CLICK_OPT_IN = 'popup_link_click_opt_in';
export const POPUP_LIVE_PREVIEW = 'popup_live_preview';
export const POPUP_PRELOAD_DELAY = 'popup_preload_delay';
export const POPUP_PRELOAD_FONTS_DELAY = 'popup_preload_fonts_delay';
export const POPUP_OPT_IN_NETWORK = 'popup_opt_in_network';
export const POPUP_OOIP = 'popup_ooitm';
export const POPUP_MIGRATE_TO_OPT_IN_NETWORK =
  'popup_migrate_to_opt_in_network';
export const POPUP_MIGRATE_TO_OPT_IN_NETWORK_DISABLED =
  'popup_migrate_to_opt_in_network_disabled';
export const POPUP_PSN = 'popup_psn';
export const POPUP_QR_BLOCK = 'popup_qr_block';
export const POPUP_SHOW_LEGACY_EDITOR = 'popup_show_legacy_editor';
export const POPUP_SINGLE_OPT_IN = 'allow_acquisition_single_opt_in';
export const POPUP_SPIN_TO_WIN = 'popup_spin_to_win';
export const POPUP_SPLIT_TEST = 'popup_split_test';
export const POPUP_SUBSCRIBER_AGE_VERIFICATION =
  'popup_subscriber_age_verification';
export const POPUP_SUBSCRIBER_TARGETING = 'popup_subscriber_targeting';
export const POPUP_TIMER_BLOCK = 'popup_timer_block';
export const POPUP_TIMER_BLOCK_FLIP_CLOCK = 'popup_timer_block_flip_clock';
export const POPUP_TIMER_BLOCK_INLINE = 'popup_timer_block_inline';
export const POPUP_TWO_TOUCH_OPT_IN_OPTION =
  'popup_two_touch_option_but_for_realsies_maybe';
export const POPUP_EDIT_DISCLAIMER_LANGUAGE = 'popup_edit_disclaimer_language';
export const POPUP_UNIQUE_IMPRESSIONS_DISPLAY =
  'popup_unique_impressions_display';
export const PROGRESSIVE_ONBOARDING_SHOPPER = 'progressive_onboarding_shopper';
export const PROGRESSIVE_ONBOARDING_PS_APP_RELEASE =
  'progressive_onboarding_ps_app_release';
export const PRODUCT_CATALOG = 'product_catalog';
export const PS_LABS = 'ps_labs';
export const PS_PAY = 'pspay';
export const RCS = 'rcs';
export const REDSHIFT_SEGMENTS = 'redshift_segments';
export const SDK_THEME_APP_EXTENSION = 'sdk_theme_app_extension';
export const SELF_MIGRATE_TO_USAGE_BILLING = 'self_migrate_to_usage_billing';
/** Used to grant GTM feature access before Shopper enabled. */
export const SHOPPER_DEBUG = 'shopper_debug';
export const SHOPPER_GTM_PREVIEW = 'shopper_gtm_preview';
export const SHOPPER_ELIGIBLE_FOR_SELF_SERVE =
  'eligible_for_shopper_self_serve';
export const SHOW_CASHBACK_PAGES = 'show_cashback_pages';
export const SLTV_DASHBOARD_DISABLED = 'sltv_dashboard_disabled';
export const SMS_SALES_CONVERSATION_INTELLIGENCE =
  'sms_sales_conversation_intelligence';
export const SMS_SALES_CONVERSATIONS = 'sms_sales_conversations';
export const SMS_SALES_NAV = 'sms_sales_nav';
export const SSAI = 'ssai';
export const SSAI_PRODUCT_CATALOGUE = 'ssai_product_catalogue';
export const SUBSCRIBER_ANALYTICS_ENABLED = 'subscriber-analytics';
export const TEXT_TO_BUY_VARIANTS = 'text_to_buy_variants';
export const TRANSACTIONAL_MESSAGES_ENABLED = 'transactional_messages_enabled';
export const USAGE_BILLING_ENABLED = 'usage_billing';
export const USAGE_BILLING_L30_REPORT = 'billing_usage_report';
export const USER_NOTIFICATION_PREFERENCES = 'user_notification_preferences';
export const USE_KLAVIYO_EVENTS_V2 = 'use_klaviyo_events_v2';
export const VERIFICATION_SOURCES_TABLE = 'verification_sources_table';
export const YOTPO_LOYALTY_V2 = 'yotpo_loyalty_v2';
export const ZERO_VIEW_ATTRIBUTION = 'zero_view_attribution';
export const FONDUE_ANALYTICS = 'fondue_analytics';

const featureFlags = [
  {
    label: 'Analytics',
    value: SUBSCRIBER_ANALYTICS_ENABLED,
  },
  {
    label: 'Usage Billing',
    value: USAGE_BILLING_ENABLED,
    disabled: true,
  },
  {
    label: 'Enable dark mode beta option',
    value: DARK_MODE,
  },
  {
    label: '(Legal Only) Exempt Shop from Terms of Service Gate',
    value: EXEMPT_FROM_SHOP_TOS_GATE,
  },
  {
    label: 'Postscript hosts dynamic Terms of Service and Privacy Policy pages',
    value: DYNAMIC_TERMS,
  },
  {
    label: 'Transactional Messages',
    value: TRANSACTIONAL_MESSAGES_ENABLED,
  },
  {
    label: 'Postscript Labs',
    value: PS_LABS,
  },
];

export default featureFlags;
